import { render } from "./FifthView.vue?vue&type=template&id=72e3c2c0&scoped=true"
import script from "./FifthView.vue?vue&type=script&lang=js"
export * from "./FifthView.vue?vue&type=script&lang=js"

import "./FifthView.vue?vue&type=style&index=0&id=72e3c2c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e3c2c0"]])

export default __exports__